<template>
    <div>
        <b-overlay :show="loaded" rounded="sm">
        <b-row>
                <div class="mt-5 d-inline-block col-6">
                    <h3 class="mobile-font">{{$translate('master_documents')}}</h3>
                </div>
                <div class="d-flex d-inline-block col-6 align-items-center justify-content-end mt-3">
                    <span class="me-2 mobile-font">{{ $translate('add_document') }}</span>
                    <div class="Click-here"></div>
                    <b-button id="add-master-document-btn" variant="blue-icon"  @click=" 
                model = {}
                isModalVisible = true
                " v-b-tooltip.hover :title="$addLabel()"><img src="@/assets/images/icon/gradient-add.svg"></b-button>
        </div>
        </b-row>
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2 m-0">
                    {{ model.id ? $translate('edit_master_document') : $translate('add_master_document') }}
                </div>
            </template>
            <!-- <b-col cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('master_document') }}<span class="red">*</span> </strong></label>
                  <b-form-select
                    id="input-name"
                    v-model="model.master_document_id"
                    :options="master_document"
                    required
                  ></b-form-select> 
                </b-col> -->
                <b-col cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{
                        $translate('master_document')
                    }}</strong></label>
                    <div class="create-select">
                        <vue-typeahead-bootstrap v-model="searchedDocument" :data="documents_data" :serializer="s => `${s?.name}`
                                " @hit="setDocument" @queryOptionsValue="queryOptionsValue" @input="lookupDocuments"
                               
                                :placeholder="$translate('search_master_document')" 
                                backgroundVariant="list-group-item list-group-item-light" />
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('sequence_number') }}</strong></label>
                    <b-form-input type="number" min="1" id="input-sequence_number" v-custom-validation="$textRequired()" v-model="model.sequence_no"
                         :placeholder="$translate('enter_sequence_number')" trim></b-form-input>
                </b-col>
            
               
                <!-- <b-row class="mt-3">
                    <b-col cols="12" class="mb-3">
                        <label><strong>{{ $translate('shared_drive') }}</strong></label>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                            v-model="model.shared_drive"
                            name="shared_drive"
                            value="yes"
                            class="mx-1"
                        >&nbsp;{{$translate('yes')}}</b-form-radio>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                            v-model="model.shared_drive"
                            name="shared_drive"
                            value="no"
                            class="mr-2"
                        >&nbsp;{{$translate('no')}}</b-form-radio>
                    </b-col>
                </b-row>
                
             -->
            <b-col cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('notes') }}</strong>
                </label>
                <b-form-textarea id="input-instructions" v-model="model.notes"
                    :placeholder="$translate('enter_instructions')" rows="3"></b-form-textarea>
            </b-col>
          
           
            <div class="d-flex justify-content-center mt-3">
                <b-button id="save-master-document-btn" size="sm" @click="createDocument" class="btn-fw me-3" 
                     variant="info">{{ model.id
                        ? $translate('update_master_document') : $translate('add_master_document') }}</b-button>
                <b-button id="close-master-document-btn" size="sm" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
                }}</b-button>
            </div>
        </b-modal>
        
        <b-col class="page-block">
            <strong>
                {{ $translate("page") }}: {{ pagination.page }}
                {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                {{ pagination.total }}
            </strong>
        </b-col>
        
        <b-row>
            <b-col md="12"  class="mobile-table">
                <b-table id="orderTable" :items="documents" :fields="fields" :per-page="itemsPerPage"
                :current-page="currentPage" :busy="tableLoading" responsive show-empty
                    ref="selectableTable"  >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
        
                    <template #empty>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
                    <template #emptyfiltered>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
        
                    <template #cell(actions)="{ item }">
                        <div class="d-flex">
                            <b-button :id="'view-master-document-'+item.id"  @click="viewItem(item)" class="me-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg">
                            </b-button>
                            <b-button :id="'delete-master-document-'+item.id" variant="pink-button" 
                                @click="deleteSchedule(item.id)"
                                ><img
                                    src="@/assets/images/icon/delete.svg"></b-button>
                        </div>
                    </template>
        
                    <template #cell(id)="{ index }">
                        <p>
                            {{ index + 1 }}
                        </p>
                    </template>
        
                  
                </b-table>
            </b-col>
        </b-row>
     
        <b-row>
            <b-col>
                <b-pagination
                    class="justify-content-center mt-4"
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageSize"
                    aria-controls="customerTable"
                    :prev-text="$translate('previous')"
                    :next-text="$translate('next')"
                    pills
                    align="center"
                ></b-pagination>
            </b-col>
        </b-row>
        </b-overlay>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins';
import permissionsMixins from '@/mixins/permissionsMixins';
import utilityMixins from "@/mixins/utilityMixins";
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'
import { debounce } from 'lodash'


export default {
    name: 'asset-schedule',
    components: {
        VueTypeaheadBootstrap
    },  
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data() {
        return {
            searchedDocument: "",
            model: {},
            isModalVisible: false,
            scheduleCreated: false,
            tableLoading: false,
            submitting: false,
            itemsPerPage: 15,
            currentPage: 1,
            loaded:true,
            filters: {
               
                queryOptionsValue: 'starts_with',
            },
          
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        crm: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        activityTypeId: {
            type: [String, Number], 
            required: true 
        },

    },
    filters: {
        // displayTime(date) {
        //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        //     console.log('timezone', timezone)
        //     if (date) {
        //         return new Date(date).toLocaleString('en-US', {
        //             timeZone: timezone,
        //         })
        //     } else {
        //         return ''
        //     }
        // },
    },
    computed: {
        componentName() {   
       
                return this.$translate('activity_type_document');
           
        },
        fields() {


            return [
              
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
                {
                    key: 'sequence_no',
                    label: this.$translate('sequence_no'),
                    
                },
                {
                    key: 'master_document',
                    label: this.$translate('master_document'),
                    formatter: (value) => value?.name,
                   
                },

                
                // {
                //     key: 'shared_drive',
                //     label: this.$translate('shared_drive'),
                   
                // },
                {
                    key: 'notes',
                    label: this.$translate('notes'),
                   
                }
              
                
            ]
        },
        master_document() {
            return this.$store.state.orderType.master_docs.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        documents() {
            console.log('data----------', this.$store.state.acitivityTypeDocStore.documents)
            return this.$store.state.acitivityTypeDocStore.documents
        },
        documents_data(){
            return this.$store.state.orderType.master_docs
        },
    
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.acitivityTypeDocStore.pagination || { page: 1 };
        },
    
    },
    watch: {
        // 'assetSchedules': {
        //     handler: function (schedules) {
        //         this.$store.dispatch('assetScheduleStore/load', schedules)
        //     },
        //     deep: true,
        // },
       
       "pagination.page": function (val) {
            console.log('page-----',val)
            this.doSearch();
        },
    },
    async mounted() {
        // const { notes } = this.order
        // const schedule_data = this.assetSchedules
        // this.scheduleCreated = false
        // this.$store.dispatch('assetScheduleStore/load', schedule_data || [])
        this.doSearch();
       
    },
    methods: {

        queryOptionsValue(val) {
            console.log("gettttt", val)
            this.filters.queryOptionsValue = val
            this.lookupDocuments()
        },
        setDocument(document) {
            console.log('assets-is',document);
            this.model.master_document_id = document.id;
         
           
        },
      
        getLabel(value) {
            const label =
                value == "task_title"
                ? this.crm
                    ? this.$translate("task_title")
                    : this.$translate("name")
                : this.$translate(value);
            return label;
        },
        viewItem(item) {
            console.log('this is callled',item);
            this.model = { ...item }
            this.searchedDocument = this.model.master_document? this.model.master_document.name : "";
            this.model.master_document_id =  this.model.master_document.id;
            this.isModalVisible = true
        },

   

    async createDocument() {
    let isError = false; 
    try {
        // const { model } = this;
        let label = "";

       
        // if (!model.name || !model.frequency || !model.order_template_id || !model.next_service_date) {
        //     throw new Error(this.$translate("schedule_error"));
        // }

        if (this.model.id) {
            label = this.$translate('updated');
            await this.$store.dispatch('acitivityTypeDocStore/updateDocument', {
                schedule: this.model,
                activityTypeId: this.activityTypeId
            });
        } else {
            label = this.$translate('created');
            await this.$store.dispatch('acitivityTypeDocStore/addDocument', {
                schedule: this.model,
                activityTypeId: this.activityTypeId
            });
        }

       
       

        this.scheduleCreated = true;

        let type_id = null
        if(this.crm){
            type_id = this.crmSettingValue.type_id;
        }
        await this.$store.dispatch('acitivityTypeDocStore/fetchdocuments', {  activityTypeId : this.activityTypeId,type_id});
       

        
        await this.doSearch();
        this.genericToast(
            this.componentName,
            label,
            'success',
            `${this.componentName} ${this.$translate('save_alert')}`
        );

      
    } catch (err) {
       
        this.doToast(
            this.$translate("error"),
            err.message,
            "danger"
        );
        isError = true; 
    } finally {
       
        if (!isError) {
            this.isModalVisible = false;
        }
    }
},


        async doSearch() {
          
            let {
                
                pagination: { page },
                
            } = this
          
          
            page = parseInt(page) || 1;

            this.tableLoading = true
            this.loaded = true;
            try{
                let type_id = null
                if(this.crm){
                    type_id = this.crmSettingValue?.type_id;
                }
              
                await this.$store.dispatch('acitivityTypeDocStore/fetchdocuments', {
                    activityTypeId : this.activityTypeId,
                    page ,
                    type_id
                })
            } catch(err) {
                console.log('fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
                this.loaded = false;
            }
        },
        // deleteMessage(hash) {
        //     this.$store.dispatch('assetScheduleStore/delete', hash)
        //     this.genericToast(
        //         this.componentName,
        //         this.$translate('deleted'),
        //         'success',
        //         `${this.componentName} ${this.$translate('delete_alert')}`
        //     )
        //     this.$emit('success', this.componentName, this.$translate('deleted'))
        // },

        async deleteSchedule(scheduleId) {
            const confirmed = confirm('Are you sure you want to delete this schedule?');

            // Proceed only if the user confirms
            if (confirmed) {
                // const { model } = this;
                await this.$store.dispatch('acitivityTypeDocStore/deleteDocument', {
                    schedule: scheduleId,
                    activityTypeId: this.activityTypeId
                });
                // Fetch the updated list of asset schedules
                await this.doSearch();
                this.genericToast(
                this.componentName,
                this.$translate('deleted'),
                'success',
                `${this.componentName} ${this.$translate('delete_alert')}`
               )
            }
        },
        lookupDocuments: debounce(function () {
            // in practice this action should be debounced
            let { searchedDocument: query, filters } = this
            delete filters.customer_id;
            query = query.split('-')[0] 
            this.$store.dispatch('master_document/fetch_data', {  query, filters })
        }, 500),

       
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
}

.created_at_class,
.user_id_class {
    width: 20% !important;
}

.id_class {
    width: 2% !important;
}

.actionButton_class {
    width: 8% !important;
}
</style>
